(function () {
let { html: $72e27d8799679615$var$html, nothing: $72e27d8799679615$var$nothing, ref: $72e27d8799679615$var$ref, createRef: $72e27d8799679615$var$createRef, CustomTokenHTMLElement: $72e27d8799679615$var$CustomTokenHTMLElement } = lithtml;
const $72e27d8799679615$var$tag = 'pages-page';
const $72e27d8799679615$var$version = '0.9.20';
let $72e27d8799679615$var$uniqueIndex = 0;
/**
 * Pages element that displays any Pages page inside an iframe
 */ class $72e27d8799679615$var$PagesPageElement extends $72e27d8799679615$var$CustomTokenHTMLElement {
    static get tag() {
        return $72e27d8799679615$var$tag;
    }
    static get version() {
        return $72e27d8799679615$var$version;
    }
    // We want to rerender each time the page or tenant attribute changes
    static get observedAttributes() {
        return [
            'page',
            'tenant'
        ];
    }
    /**
     * Constructor
     */ constructor(){
        super($72e27d8799679615$var$PagesPageElement);
        let self = this;
        self._ao = `wcid_${new Date().getTime()}_${++$72e27d8799679615$var$uniqueIndex}`;
        self._ap = $72e27d8799679615$var$createRef();
        self._aq = self._aq.bind(self);
    }
    /**
     * The rendered component
     */ render() {
        let self = this;
        let tenant = self.tenant;
        let page = self.page;
        let baseUrl = self.baseUrl;
        if (!(tenant && page)) return $72e27d8799679615$var$nothing;
        if (tenant.indexOf('{') !== -1 || page.indexOf('{') !== -1) return $72e27d8799679615$var$nothing;
        if (!baseUrl) {
            let environment = self.getAttribute('environment');
            // Should only come here if we're not depending on tokens
            if (tenant === 'public' && environment) baseUrl = self.baseUrl = self._ar(environment === 'prod' ? 'idsrv.onpowel.com' : environment === 'qa' ? 'qaidsrv' : 'ciidsrv');
            else return $72e27d8799679615$var$nothing;
        }
        let urlParams = (self.getAttribute('urlparams') || '').trimStart('?');
        urlParams = `${urlParams}${urlParams ? '&' : ''}$wcid=${self._ao}`;
        return $72e27d8799679615$var$html`<style>:host{display:block;contain:content;overflow:hidden}iframe{margin:0;padding:0;width:100%;height:100%;overflow:hidden}</style>${baseUrl ? $72e27d8799679615$var$html`<iframe ${$72e27d8799679615$var$ref(self._ap)} sandbox="allow-downloads allow-scripts allow-same-origin allow-forms allow-popups allow-modals allow-popups-to-escape-sandbox" frameBorder="0" src="${baseUrl + '/' + tenant + (self._as && tenant !== 'public' ? '/home' : '') + '?' + urlParams + '#/' + page}"></iframe>` : $72e27d8799679615$var$html`<div style="color:red">Could not find Pages url (no baseurl/environment attribute set and the location is unknown)!</div>`}`;
    }
    onRendered() {
        // If we have the user data and the iframe is ready, send the user data to the iframe
        // The reason we may need this here, in addition to the onUserData event, is that the first call to
        // onUserData may come before the iframe is ready.
        if (this._at && this._ap.value) this.onUserData(this._at);
    }
    /**
     * Make sure we attach listener for postMessage's coming from the iframe
     */ onConnected() {
        window.removeEventListener('message', this._aq);
        window.addEventListener('message', this._aq);
    }
    /**
     * Clean up when the component is disconnected from the DOM
     */ onDisconnected() {
        window.removeEventListener('message', this._aq);
    }
    /**
     * Listen on messages from the iframe
     */ _aq(event) {
        let self = this;
        let data = event.data;
        // Only interested in messages from the iframe in this component
        if (data.wcid !== self._ao) return;
        if (data.event === '$pages.needuserinfoandtoken') {
            self.$triggerEvent('web-component-needUserInfoAndToken');
            return;
        }
        self.$triggerEvent($72e27d8799679615$var$PagesPageElement.tag + '-pageevent', {
            data: data
        });
    }
    /**
     * Sends the userinfo and token to the iframe
     */ onUserData(userData) {
        let self = this;
        let token = JSON.parse(window.atob(userData.accessToken.split('.')[1]));
        if (!self.baseUrl) {
            self._as = token.iss.indexOf('powel.net') !== -1;
            self.baseUrl = self._ar(token.iss);
            if (!self.tenant) {
                let clientIdSplit = token.client_id.split('_');
                self.tenant = clientIdSplit[clientIdSplit.length - 1];
            }
            self.requestRender('baseurlretrieved');
        }
        // Keep the user data for later if the iframe is not ready yet
        self._at = userData;
        self._ap?.value?.contentWindow?.postMessage({
            event: '$pages.userinfoandtoken',
            data: userData
        }, self.baseUrl);
    }
    /**
     *
     * @param {string} tokenIssuerUrl
     */ _ar(tokenIssuerUrl) {
        let environment = this.getAttribute('environment');
        if (environment === 'local') return 'https://water.local.voluead.volue.com';
        return 'https://' + (tokenIssuerUrl.indexOf('onpowel') > 0 || origin.indexOf('powel.net') > 0 ? 'pages.onpowel.com' : tokenIssuerUrl.indexOf('qaidsrv') > 0 ? 'powelappqawater.azurewebsites.net' : 'powelappciwater.azurewebsites.net');
    }
    /** Called when destroy has been called on the element, so we do some cleanup */ onDestroy() {
        super.onDestroy();
        let self = this;
        self._ap = null;
        self._ao = null;
        self._at = null;
    }
}
// Define the new web component
if (!window.customElements.get($72e27d8799679615$var$tag)) window.customElements.define($72e27d8799679615$var$tag, $72e27d8799679615$var$PagesPageElement);

})();
//# sourceMappingURL=pages-page.js.map
